<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
      dense
    >
      <v-col
        cols="12"
        md="6"
        dense
      >
        <v-card class="py-10 px-10">
          <p class="title">ログインパスワードの変更</p>
          <v-card flat outlined class="pa-3">
            <div class="subtitle-2 mb-2">
              <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
              <span class="primary--text">パスワードの変更について</span>
            </div>
            <p class="caption">
              現在のパスワードと新しいパスワードを入力してください。<br>
              新しいパスワードは、「新しいパスワード」と「新しいパスワード（確認）」に同じものを入力してください。<br>
              パスワード欄に入力後、「パスワードを変更する」ボタンをクリックしてください
            </p>
          </v-card>
          <v-text-field v-model="CurrentPassword" 
            label="現在のパスワード"
            :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showCurrentPassword ? 'text' : 'password'"
            @click:append="showCurrentPassword = !showCurrentPassword"
            class="mt-5"
             dense
          ></v-text-field>
          <v-text-field v-model="NewPassword"
            label="新しいパスワード"
            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showNewPassword ? 'text' : 'password'"
            @click:append="showNewPassword = !showNewPassword"
            :rules="[rules.min]"
            dense
          ></v-text-field>
          <v-text-field v-model="NewPasswordConfirm"
            label="新しいパスワード（確認）"
            :append-icon="showNewPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showNewPasswordConfirm ? 'text' : 'password'"
            @click:append="showNewPasswordConfirm = !showNewPasswordConfirm"
            :rules="[rules.min]"
            dense
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-row dense class="mt-5">
            <v-col cols="12" class="text-right">
              <v-btn rounded color="amber darken-1" @click="changePassword()" data-createApplication class="px-2"><v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>パスワードを変更する</v-btn> 
            </v-col>
          </v-row>
          <!-- <br>{{message}} -->
      </v-card>    
      </v-col>
    </v-row>
    <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>

    <v-dialog
      v-model="isErrored"
      max-width="500"
    >
      <v-card>
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="red darken-1" x-large>mdi-alert-circle</v-icon></div>
            パスワードの変更に失敗しました。<br>
            下記の条件を満たすパスワードを入力してください<br>
            <br>
            <v-card outlined>
             <v-card-text class="text-left">
                <p><v-icon color="teal darken-1" class="mr-2">mdi-check</v-icon>8文字以上</p>
                <p><v-icon color="teal darken-1" class="mr-2">mdi-check</v-icon>半角英数字のみ</p>
                <p><v-icon color="teal darken-1" class="mr-2">mdi-check</v-icon>英字大文字小文字数字がそれぞれ１種類ずつ含まれること</p>
                <p><v-icon color="teal darken-1" class="mr-2">mdi-check</v-icon>現在のパスワードと違うこと</p>
             </v-card-text>
            </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            block
            @click="isErrored=false"
            class="white--text mb-5"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isAuthErrored"
      max-width="300"
    >
      <v-card>
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="red darken-1" x-large>mdi-alert-circle</v-icon></div>
            パスワードの認証に失敗しました。<br>
            正しいパスワードを入力してください<br>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            block
            @click="isAuthErrored=false"
            class="white--text mb-5"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
</template>

<script>
import { Auth } from 'aws-amplify'
import Successed from "../components/successDialog.vue"
import validations from '../utils/validations.js'
import { required, helpers, sameAs, not } from 'vuelidate/lib/validators'

//const pwValidate = helpers.regex('pwValidate', /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/)
const pwValidate = helpers.regex('pwValidate', /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[A-Za-z\d@$*.!@#.:_~]{8,100}$/)

export default {
  mixins:[validations],  
  name: "CustomChangePassword",
  head: {
    title: { inner: 'パスワード変更'},
  },
  components: {
    sucDialog: Successed
  },  

  data() {
    return {
      CurrentPassword: "",
      NewPassword: "",
      NewPasswordConfirm: "",
      isSuccessed: false,
      isErrored: false,
      isAuthErrored: false,
      showCurrentPassword: false,
      showNewPassword: false,
      showNewPasswordConfirm: false,
      successUrl: '/auth',
      successText: 'パスワードが変更されました。<br>新しいパスワードでログインしなおしてください。',
      failureUrl: '/',
      message: "",
      rules: {
        min: v => v.length >= 8 || 'パスワードは8文字以上にしてください',
      },      
    };
  },
  validations: {
    NewPassword: { pwValidate, required},
    NewPasswordConfirm: { sameAsPassword: sameAs('NewPassword') },
    CurrentPassword: { notSameAsPassword: not(sameAs('NewPassword'))}
  },
  methods: {
    changePassword: async function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
          console.log('error: ', 'validation error')
          this.isErrored = true
          return
      }
      this.$Amplify.Auth.currentAuthenticatedUser()
        .then(user => {
            return Auth.changePassword(user, this.CurrentPassword, this.NewPassword);
        }).then(data => {
            console.log(data)
  //          this.isSuccessed = true
            this.$Amplify.Auth.signOut();
            this.$refs.isSuccessed.open();
        }).catch(err => {
            console.log("changePassword error code:", err.code)
            console.log("changePassword error message:", err.message)
            this.message = err.message
            this.isAuthErrored = true
          });
    },
    showDialog () {
      this.isSuccessed = false
      this.$Amplify.Auth.signOut();
      this.signedIn = false;
      this.$store.commit('setInitializedUser', false )
      this.$router.push("/auth");
      },
    },
  };
</script>
